// @ts-nocheck
import moment from 'moment';
import {
  AcceptingDrive,
  AcceptingDriveData,
  AcceptingFormData,
  DriveFormData,
  DriveInfo,
  DrivePatch,
  DrivesForm,
  PlannerFormData,
  PostAcceptingDrive,
} from '@common/interfaces';
import { TRANSFER_TYPES, TRIP_TYPES } from '@common/constants';

// TODO: Will be refactored in the future =======================================
// Old Mobility Planner =========================================================
// ==============================================================================
export default class Serializer {
  public static acceptingDriveToPostDrive(acceptDrives: AcceptingDrive[]): PostAcceptingDrive {
    return {
      booking: acceptDrives[0].booking,
      drives: acceptDrives.map((drive) => ({
        vehicle: drive.vehicle,
        driver: drive.driver,
        pickup_date: drive.pickup_date,
        pickup_time: drive.pickup_time,
        pickup_location: drive.pickup_location,
        pickup_town: drive.pickup_town,
        dropoff_date: drive.dropoff_date,
        dropoff_time: drive.dropoff_time,
        dropoff_location: drive.dropoff_location,
        dropoff_town: drive.dropoff_town,
      })),
    };
  }

  public static mapPlannerFormData(data: DriveFormData): PlannerFormData {
    const { type_of_trip, transfer_type, currentDate } = data;
    let drives: DriveInfo[] = [];

    const agencyName = data?.main_info?.agency_name ?? data?.main_info?.agency?.label;
    const agencyId = data?.main_info?.agency?.value;

    if (
      type_of_trip?.value === TRIP_TYPES.ONE_WAY ||
      transfer_type === TRANSFER_TYPES.FROM_TO_AIRPORT
    ) {
      drives.push({
        vehicle: data.vehicle?.value,
        driver: data.driver?.value,
        pickup_date: moment(data.pickup_date).format('YYYY-MM-DD') ?? '',
        pickup_time: moment(data.pickup_time).format('HH:mm') ?? '',
        pickup_location: data.pickup_location,
        pickup_town: data.pickup_town,
        dropoff_date: moment(data.dropoff_date).format('YYYY-MM-DD'),
        dropoff_time: moment(data.dropoff_time).format('HH:mm'),
        dropoff_location: data.dropoff_location,
        dropoff_town: data.dropoff_town,
      });
    } else if (type_of_trip?.value === TRIP_TYPES.ROUND_TRIP) {
      drives.push({
        vehicle: data.vehicle?.value,
        driver: data.driver?.value,
        pickup_date: moment(data.pickup_date).format('YYYY-MM-DD') ?? '',
        pickup_time: moment(data.pickup_time).format('HH:mm') ?? '',
        pickup_location: data.pickup_location,
        pickup_town: data.pickup_town,
        dropoff_date: moment(data.dropoff_date).format('YYYY-MM-DD'),
        dropoff_time: moment(data.dropoff_time).format('HH:mm'),
        dropoff_location: data.dropoff_location,
        dropoff_town: data.dropoff_town,
      });

      drives.push({
        vehicle: data.vehicle_return?.value,
        driver: data.driver_return?.value,
        pickup_date: moment(data.pickup_date_return).format('YYYY-MM-DD') ?? '',
        pickup_time: moment(data.pickup_time_return).format('HH:mm') ?? '',
        pickup_location: data.pickup_location_return ?? '',
        pickup_town: data.pickup_town_return ?? '',
        dropoff_date: moment(data.dropoff_date_return).format('YYYY-MM-DD'),
        dropoff_time: moment(data.dropoff_time_return).format('HH:mm'),
        dropoff_location: data.dropoff_location_return ?? '',
        dropoff_town: data.dropoff_town_return ?? '',
      });
    } else if (type_of_trip?.value === TRIP_TYPES.MULTI_LEG) {
      drives = data.drives.map((drive) => ({
        ...drive,
        pickup_date: moment(drive.pickup_date).format('YYYY-MM-DD'),
        pickup_time: moment(drive.pickup_time).format('HH:mm'),
        dropoff_date: moment(drive.dropoff_date).format('YYYY-MM-DD'),
        dropoff_time: moment(drive.dropoff_time).format('HH:mm'),
        vehicle: drive.vehicle.value,
        driver: drive.driver.value,
      }));
    }

    const nPassengers = parseInt(data.n_of_passengers?.value ?? '0', 10);

    const submitData = {
      is_booking_on_behalf_of_colleague: false,
      has_passengers: nPassengers > 0,
      booking_details: {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        agency: agencyName,
        agency_fk: agencyId,
        phone_number: data.phone_number,
        index_number: data.index_number,
      },
      driver_detail: {
        transfer_type: data.transfer_type,
        type_of_trip: data.type_of_trip?.value ?? TRIP_TYPES.ONE_WAY,
        passenger_infos: [],
      },
      booking_extra: {
        manager_email: data.manager_email ?? '',
        purpose: data.purpose?.value,
        remarks: data.remarks,
        n_of_passengers: nPassengers,
        requesting_unit: data.requesting_unit?.value ?? '',
      },
      drives,
    } as PlannerFormData;

    if (data.addingRecurring) {
      const pickupDate = submitData.drives[0].pickup_date;

      submitData.recurring_option = {
        start_date: pickupDate || moment(currentDate).format('YYYY-MM-DD'),
        end_date: moment(data.recurring_until).format('YYYY-MM-DD'),
        frequency: data.recurring_period?.value,
      };

      if (data.recurring_period?.value === '3' && data.recurring_frequency) {
        const frequencyValue = +data.recurring_frequency;
        submitData.recurring_option.weekdays =
          frequencyValue === 6 ? [...Array(4).keys(), 6] : [...Array(frequencyValue).keys()];
      }
    }

    return submitData;
  }

  public static mapPlannerFormDataToUpdateDrive(
    data: DriveFormData,
    locationId: number,
  ): DrivePatch {
    let driver;
    let vehicle;
    let pickup_location;
    let dropoff_location;
    let dropoff_town;
    let pickup_town;
    let pickup_date;
    let dropoff_date;
    let pickup_time;
    let dropoff_time: any;

    const agencyName = data?.main_info?.third_party
      ? data?.main_info?.agency_name
      : data?.main_info?.agency?.label;
    const agencyId = data?.main_info?.agency?.value;

    if (data.type_of_trip?.value === TRIP_TYPES.MULTI_LEG && data.drives.length) {
      const driveLeg = data.drives[0];

      driver = driveLeg.driver.value;
      vehicle = driveLeg.vehicle.value;
      pickup_town = driveLeg.pickup_town;
      dropoff_town = driveLeg.dropoff_town;
      pickup_location = driveLeg.pickup_location;
      dropoff_location = driveLeg.dropoff_location;
      pickup_date = moment(driveLeg.pickup_date).format('YYYY-MM-DD');
      pickup_time = moment(driveLeg.pickup_time).format('HH:mm');
      dropoff_date = moment(driveLeg.dropoff_date).format('YYYY-MM-DD');
      dropoff_time = moment(driveLeg.dropoff_time).format('HH:mm');
    } else {
      driver = data.driver ? data.driver.value : null;
      vehicle = data.vehicle ? data.vehicle.value : null;
      pickup_town = data.pickup_town;
      dropoff_town = data.dropoff_town;
      pickup_location = data.pickup_location;
      dropoff_location = data.dropoff_location;
      pickup_date = moment(data.pickup_date).format('YYYY-MM-DD');
      pickup_time = moment(data.pickup_time).format('HH:mm');
      dropoff_date = moment(data.dropoff_date).format('YYYY-MM-DD');
      dropoff_time = moment(data.dropoff_time).format('HH:mm');
    }

    return {
      booking: {
        transfer_type: data.transfer_type,
        type_of_trip: data.type_of_trip ? data.type_of_trip.value : TRIP_TYPES.ONE_WAY,
        first_name: data.first_name ? data.first_name : '',
        last_name: data.last_name ? data.last_name : '',
        email: data.email ? data.email : '',
        agency: agencyName,
        agency_fk: agencyId,
        manager_email: data.manager_email ? data.manager_email : '',
        phone_number: data.phone_number ? data.phone_number : '',
        n_of_passengers: data.n_of_passengers ? data.n_of_passengers.value : 0,
        index_number: data.index_number ? data.index_number : '',
        requesting_unit: data.requesting_unit ? data.requesting_unit.value : '',
        purpose: data.purpose?.value,
        remarks: data.remarks,
        facility: parseFloat(locationId),
      },
      driver,
      vehicle,
      pickup_location,
      dropoff_location,
      dropoff_town,
      pickup_town,
      dropoff_date,
      dropoff_time,
      pickup_date,
      pickup_time,
      has_passengers: !data.no_passengers,
    };
  }

  public static mapAcceptingFormToPostData(data: AcceptingDriveData[]): AcceptingFormData {
    const drives: DrivesForm[] = [];

    data.forEach((item: AcceptingDriveData) => {
      drives.push({
        driver: item.driver ? item.driver : 0,
        dropoff_date: item.dropoff_date,
        dropoff_location: item.dropoff_location,
        dropoff_time: item.dropoff_time,
        dropoff_town: item.dropoff_town,
        pickup_date: item.pickup_date,
        pickup_location: item.pickup_location,
        pickup_time: item.pickup_time,
        pickup_town: item.pickup_town,
        vehicle: item.vehicle ? item.vehicle : 0,
      });
    });

    return { drives };
  }
}
